module.exports = {"421023100":"容城镇","421023101":"朱河镇","421023102":"新沟镇","421023103":"龚场镇","421023104":"周老嘴镇","421023105":"黄歇口镇","421023106":"汪桥镇","421023107":"程集镇","421023108":"分盐镇","421023109":"毛市镇","421023110":"福田寺镇","421023111":"上车湾镇","421023112":"汴河镇","421023113":"尺八镇","421023114":"白螺镇","421023115":"网市镇","421023116":"三洲镇","421023117":"桥市镇","421023200":"红城乡","421023201":"棋盘乡","421023202":"柘木乡","421023450":"人民大垸农场管理区","421023451":"荒湖农场管理区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421023.json
// module id = 1616
// module chunks = 0